export const groupPackages1 = [
    {
        id: "1",
        tourTitle: "Singapore And Malaysia",
        tags: ["Group Tour", "Family", "Popular Today"],
        imageUrl: "/images/group-package-1.jpg",
        reviews: 148,
        rating: 5,
        inclusive: ['Hotels', 'Food', 'Flight', 'Sightseeing', 'Local Transport', 'Visa', 'Tour Guide'],
        description: "Explore the vibrant cities of Singapore and Malaysia with our 7-day group tour, featuring iconic landmarks, cultural experiences, and delicious cuisine.",
        price: {
            currency: "INR",
            total: 140000,
            emi: 4789,
            emiFrequency: "monthly",
            personType: "per person on twin sharing"
        },
        destinations: {
            days: 7,
            countries: [{
                name: "Singapore",
                city: ['Singapore']
            },
            {
                name: "Malaysia",
                city: ['Kuala Lumpur', 'Malacca', 'Penang']
            }]
        },
        depatures: [{ city: 'Delhi', date: '2025-12-01' }, { city: 'Mumbai', date: '2025-12-01' }],
        highlights: [
            "Universal Studios",
            "Gardens By The Bay",
            "Marina Bay"
        ],
        category: "Family",
        itinerary: [
            { day: 1, title: "Arrival in Singapore", description: "Arrive at Changi Airport and transfer to your hotel. Evening at leisure to explore Marina Bay." },
            { day: 2, title: "Singapore City Tour", description: "Visit Gardens by the Bay, Merlion Park, and Marina Bay Sands SkyPark." },
            { day: 3, title: "Universal Studios & Sentosa", description: "Enjoy a full day at Universal Studios Singapore and Sentosa Island attractions." },
            { day: 4, title: "Travel to Malaysia - Kuala Lumpur", description: "Depart to Kuala Lumpur. Evening visit to Petronas Towers and Bukit Bintang." },
            { day: 5, title: "Malacca Heritage Tour", description: "Explore the historic town of Malacca with its colonial architecture and local cuisine." },
            { day: 6, title: "Penang Exploration", description: "Discover George Town's street art, temples, and local flavors." },
            { day: 7, title: "Departure", description: "Transfer to the airport for your flight home with wonderful memories." }
        ]
    },
    {
        id: "2",
        tourTitle: "Singapore to Malaysia Explorer",
        tags: ["Group Tour", "Family", "Popular Today"],
        imageUrl: "/images/group-package-1.jpg",
        rating: 4.5,
        inclusive: ['Hotels', 'Food', 'Flight', 'Sightseeing', 'Local Transport', 'Visa', 'Tour Guide'],
        description: "Explore the vibrant cities of Singapore and Malaysia with our 7-day group tour, featuring iconic landmarks, cultural experiences, and delicious cuisine.",
        price: {
            currency: "INR",
            total: 145000,
            emi: 4889,
            emiFrequency: "monthly",
            personType: "per person on twin sharing"
        },
        destinations: {
            days: 10,
            countries: [{
                name: "Singapore",
                city: ['Singapore', 'shanghai']
            },
            {
                name: "Malaysia",
                city: ['Kuala Lumpur', 'Malacca', 'Penang']
            }]
        },
        depatures: [{ city: 'Mumbai', date: '2025-12-01' }],
        highlights: [
            "Universal Studios",
            "Gardens By The Bay",
        ],
        category: "Family",
        itinerary: [
            { day: 1, title: "Arrival and Welcome", description: "Arrive and settle into your hotel. Evening welcome dinner." },
            { day: 2, title: "City Highlights", description: "City sightseeing including major landmarks and local markets." },
            { day: 3, title: "Cultural Excursions", description: "Visit cultural sites and experience local cuisine and traditions." },
            { day: 4, title: "Leisure & Shopping", description: "Free day to explore or relax, optional shopping in malls and bazaars." },
            { day: 5, title: "Departure", description: "Final day, transfer to the airport for departure." }
        ]
    }
];

export default groupPackages1;
